"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 65 80';

var Summary = function Summary() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M14.41,36H32.87a2.5,2.5,0,0,0,0-5H14.41a2.5,2.5,0,1,0,0,5Z"
  }), _react["default"].createElement("path", {
    d: "M11.91,46.63a2.5,2.5,0,0,0,2.5,2.5H44.34a2.5,2.5,0,0,0,0-5H14.41A2.5,2.5,0,0,0,11.91,46.63Z"
  }), _react["default"].createElement("path", {
    d: "M44.34,57.32H14.41a2.5,2.5,0,0,0,0,5H44.34a2.5,2.5,0,0,0,0-5Z"
  }), _react["default"].createElement("path", {
    d: "M58,19.47,39.53,1a3.33,3.33,0,0,0-2.4-1H11.5A11.51,11.51,0,0,0,0,11.5v53A11.51,11.51,0,0,0,11.5,76h36A11.51,11.51,0,0,0,59,64.5V21.87A3.33,3.33,0,0,0,58,19.47ZM40,8.54,51.46,20H40Zm14,56A6.51,6.51,0,0,1,47.5,71h-36A6.51,6.51,0,0,1,5,64.5v-53A6.51,6.51,0,0,1,11.5,5H35V21.6A3.41,3.41,0,0,0,38.4,25H54Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Summary, {
  viewBox: viewBox
});

exports["default"] = _default;